export default (vals) => Number(
  Object.values(vals)
    .map((e) => e.v)
    .reduce((avg, value, index, { length }) => avg + value / length, 0),
).toFixed(1);
